export const CarouselTypes = {
    CASE_STUDIES: 'caseStudies',
    GALLERY: 'gallery',
    TESTIMONIALS: 'testimonials',
    TESTIMONIALS_CLUTCH: 'testimonials_clutch',
    SERVICES: 'services',
    PROCESS: 'process',
    GALLERY_TYPES: {
        CAREER_LANDSCAPE: 'careeerLandscape',
        CAREER_PORTRAIT: 'careeerPortrait',
        CONTACT_OFFICES: 'contactOffices',
    },
    WORKSHOP_PROCESS: 'workshopProcess',
};

export const DeviceTypes = {
    PHONE: 'phone',
    DESKTOP: 'desktop',
};
